module.exports = __webpack_public_path__ + "static/media/all-in-one-icon.016dcd01.svg";